import "../css/app.css"
import "./app"

if (module.hot) {
  module.hot.accept()
}
